export const getAddingAnim = store => store.addingAnim
